import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { buildTenantPath, extractTenantSlugFromPathname } from '../../utils/tenantSlug';

const CompleteLoginPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const auth = getAuth();
  const tenantSlug =
    typeof window !== 'undefined'
      ? extractTenantSlugFromPathname(window.location.pathname)
      : null;

  useEffect(() => {
    const completeSignIn = async () => {
      if (isSignInWithEmailLink(auth, window.location.href)) {
        let email = window.localStorage.getItem('emailForSignIn');
        
        if (!email) {
          email = window.prompt('Por favor, forneça seu email para confirmação');
        }

        if (email) {
          try {
            await signInWithEmailLink(auth, email, window.location.href);
            window.localStorage.removeItem('emailForSignIn');
            toast.success('Login realizado com sucesso!');
          } catch (error) {
            console.error('Error completing sign in:', error);
            toast.error('Erro ao completar login. Por favor, tente novamente.');
            navigate(buildTenantPath('/login', tenantSlug));
          }
        } else {
          navigate(buildTenantPath('/login', tenantSlug));
        }
      } else {
        navigate(buildTenantPath('/login', tenantSlug));
      }
      setIsLoading(false);
    };

    completeSignIn();
  }, [auth, navigate, tenantSlug]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <div className="text-center">
          <div className="inline-block h-8 w-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-neutral-600">Completando login...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default CompleteLoginPage;
